import {
  type InventoryContentIdsTypeOption,
  InventoryContentOption,
} from '@openx/types/targeting/inventoryAndContent.ts';

export const isOptionsIdsTypeCheck = (
  contentOption: InventoryContentOption
): contentOption is InventoryContentIdsTypeOption =>
  contentOption === InventoryContentOption.PUBLISHER_ID ||
  contentOption === InventoryContentOption.INSTANCE_HASH ||
  contentOption === InventoryContentOption.ADUNIT ||
  contentOption === InventoryContentOption.LINE_ITEM_APP_BUNDLE_ID ||
  contentOption === InventoryContentOption.SITE;
